import { HttpService } from '../http';
import { RoutingService } from '../routing';
import { LogicalUnitBaseService } from './logicalunit-base.service';
import { IOpenModalLogicalUnitParams } from './logicalunit-modal.interface';

/**
 * Base logical unit service.
 *
 * @export
 * @abstract
 * @class LogicalUnitBaseService
 */
export abstract class LogicalUnitModalBaseService extends LogicalUnitBaseService {
    public modalOptions: any;

    /**
     * Parameters the modal was opened with (component, injector, canActivate/canDeactivate, ...).
     * Set by {@link ModalService.openLogicalUnit} before the modal component is created, and read
     * by {@link LogicalUnitModalBaseComponent}'s constructor.
     */
    public openingParams: IOpenModalLogicalUnitParams<any>;

    constructor(
        public override routingService: RoutingService,
        httpService: HttpService,
    ) {
        super(routingService, httpService);

        this.luType = 'Modal';
    }
    onRedirectAfterClose: () => void;
}
